import { render, staticRenderFns } from "./FormtextItem.vue?vue&type=template&id=13c7cfc7&scoped=true"
import script from "./FormtextItem.vue?vue&type=script&lang=js"
export * from "./FormtextItem.vue?vue&type=script&lang=js"
import style0 from "./FormtextItem.vue?vue&type=style&index=0&id=13c7cfc7&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c7cfc7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13c7cfc7')) {
      api.createRecord('13c7cfc7', component.options)
    } else {
      api.reload('13c7cfc7', component.options)
    }
    module.hot.accept("./FormtextItem.vue?vue&type=template&id=13c7cfc7&scoped=true", function () {
      api.rerender('13c7cfc7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/applet/setting/skinSetting/components/FormtextItem.vue"
export default component.exports